import $ from "jquery";
import "../controllers/property_searches_controllers";

import "../src/plugins/Tabby";
import "../src/plugins/Gmap";
import "../src/plugins/UserPilot";

import "../src/custom/channels/timeout";
import Rails from "@rails/ujs";
import { initIBSearchScripts } from "../src/custom/events/ibSearch";
import { initializeSemanticUI } from "../src/plugins/SemanticUI";
import {
  checkProposalRequestStatus,
} from "../src/custom/events/proposal_request";
import "../src/custom/Modal";
import "../src/custom/HeaderInit";

import "../controllers/global_controllers";

// eslint-disable-next-line no-multi-assign
window.$ = window.JQuery = window.jQuery = $;
// eslint-disable-next-line import/no-unresolved, import/extensions
require("semantic/semantic.min.js");

// eslint-disable-next-line no-underscore-dangle
if (!window._rails_loaded) {
  Rails.start();
}

const init = () => {
  document.dispatchEvent(new Event("timeout:init"));
  initializeSemanticUI();

  const roomSelectionForm = document.querySelector("[data-max-rooms]");
  if (roomSelectionForm) {
    initIBSearchScripts(roomSelectionForm.dataset.maxRooms);
  }

  const bookingProcessingContainer = document.querySelector(
    "#proposal-request-processing-screen",
  );
  if (bookingProcessingContainer) {
    checkProposalRequestStatus(bookingProcessingContainer);
    document.addEventListener("booking:poll", () => {
      checkProposalRequestStatus(bookingProcessingContainer);
    });
  }
};

document.addEventListener("DOMContentLoaded", init);
